import { type } from '@/utils/type'


export const MAPLAYER_REQUEST = type('MAPLAYER_REQUEST')
export const MAPLAYER_SUCCESS = type('MAPLAYER_SUCCESS')
export const MAPLAYER_ERROR = type('MAPLAYER_ERROR')

export const MAPLAYER_ENSURE_LIST = type('MAPLAYER_ENSURE_LIST')
export const MAPLAYER_ENSURE_DETAIL = type('MAPLAYER_ENSURE_DETAIL')

export const MAPLAYER_SELECT_DETAIL_REQUEST = type('MAPLAYER_SELECT_DETAIL_REQUEST')
export const MAPLAYER_SELECT_DETAIL_SUCCESS = type('MAPLAYER_SELECT_DETAIL_SUCCESS')
export const MAPLAYER_SELECT_DETAIL_ERROR = type('MAPLAYER_SELECT_DETAIL_ERROR')
export const MAPLAYER_SELECT_DETAIL = type('MAPLAYER_SELECT_DETAIL')

export const MAPLAYER_SAVE_REQUEST = type('MAPLAYER_SAVE_REQUEST')
export const MAPLAYER_SAVE_SUCCESS = type('MAPLAYER_SAVE_SUCCESS')
export const MAPLAYER_SAVE_ERROR = type('MAPLAYER_SAVE_ERROR')

export const MAPLAYER_UPDATE_MODIFIED_ADM = type('MAPLAYER_UPDATE_MODIFIED_ADM')
export const MAPLAYER_CANCEL_MODIFIED_ADM = type('MAPLAYER_CANCEL_MODIFIED_ADM')

export const MAPLAYER_UPDATE_FILTER_ADM = type('MAPLAYER_UPDATE_FILTER_ADM')

export const MAPLAYER_DELETE_REQUEST = type('MAPLAYER_DELETE_REQUEST')
export const MAPLAYER_DELETE_SUCCESS = type('MAPLAYER_DELETE_SUCCESS')
export const MAPLAYER_DELETE_ERROR = type('MAPLAYER_DELETE_ERROR')

export const MAPLAYER_SET_GROUP_NAME_REQUEST = type('MAPLAYER_SET_GROUP_NAME_REQUEST')
export const MAPLAYER_SET_GROUP_NAME_SUCCESS = type('MAPLAYER_SET_GROUP_NAME_SUCCESS')
export const MAPLAYER_SET_GROUP_NAME_ERROR = type('MAPLAYER_SET_GROUP_NAME_ERROR')
